import React, { Component } from "react";
import ImageOnlyUpload from "../../pages/ImageOnlyUpload";
import TextEditor from "../TextEditor";
import Slider from "react-slick";
import UploadForm from "../UploadForm";
import { Player } from "video-react";
import PlusIcon from "../../icons/plusicon";
import { PlayToggle } from "video-react";
import DeletefileIcon from "../../icons/DeletefileIcon";
import CopyIcon from "../../icons/copyicon";
import { ControlBar } from "video-react";
import Loader from "../loader";
//moment import
import moment from "moment-timezone";
import _ from 'lodash'
import VideoImageFile from "../VideoImageFile";
import VideoOnlyUpload from "../../pages/VideoOnlyUpload";

// Editors
import { Editor } from "react-draft-wysiwyg";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import { convertFromRaw } from "draft-js";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
//Validation import
import SimpleReactValidator from "simple-react-validator";
//import AWS from "aws-sdk";
import AWS from "aws-sdk";
//Service import
import service from "../../services";
import PopUpCustomAll from "../fpg/create/popUpCustomAll";
import ErrorPopUp from "../errorPopUp";
import commonImage from "../../commonImage";

let sub;

const EXT_IMAGES = /\.(svg|png|apng|jpeg|jpg|ico|hdr|bmp|webp|gif|tiff|tif|jp2|rgb|dds|cur|tga|heic|jfif|pgm|jpe|xpm|exr|map|ppm|g3|wbmp|jbg|pcx|pdb|avif|jps|rgba|heif|fax|xbm|yuv|pcd|pict|xwd|pal|vips|pgx|pbm|jbig|picon|ras|pct|fts|hrz|ipl|mng|mtv|otb|palm|pam|pfm|pnm|rgbo|sgi|sun|uyvy|viff|xv|g4|rgf|six|sixel|jif|jfi)$/i;
const EXT_VIDEO = /\.(avi|wmv|mpeg|webm|mov|mpg|divx|mpeg-2|3gp|flv|swf|m4v|ogv|mkv|mjpeg|vob|xvid|mts|av1|ts|avchd|hevc|asf|mxf|m2v|3g2|rmvb|m2ts|wtv|f4v|rm|mp4)$/i;

const content = {
  entityMap: {},
  blocks: [
    {
      key: "637gr",
      text: "Initialized from content state.",
      type: "unstyled",
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {}
    }
  ]
};
export default class ArtistsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      getAllArtistsPagedetails: "",
      imagePreloader: false,
      loaderFlag: false,
      isImage: false,
      editorState: EditorState.createEmpty(),
      media: [
        {
          _id: Math.random(),
          mediaImage: "",
          mediaUrl: ""
        },
        {
          _id: Math.random(),
          mediaImage: "",
          mediaUrl: ""
        },
        {
          _id: Math.random(),
          mediaImage: "",
          mediaUrl: ""
        }
      ],
      pageTitle: "",
      pageDescription: EditorState.createEmpty()
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  componentDidMount() {
    this.getArtists();
    this.getArtistsEvent();
    this.setState({
      loaderFlag: true
    });
  }

  // Dummy API
  getArtistsEvent = () => {
    sub = this.apiserve.getevent().subscribe(response => {
      switch (response.event) {
        case "FestivalVillage|ArtistLounge|ArtistLoungePage|getList":
          if (!response.error) {
            this.setState({
              getAllArtistsPagedetails: response.data
            });
            if (this.state.pageDescription) {
              const blocksFromHtml = htmlToDraft(
                response.data.pageDescription ? response.data.pageDescription : ""
              );
              const { contentBlocks, entityMap } = blocksFromHtml;
              const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
              const pageDescription = EditorState.createWithContent(contentState);
              this.setState({
                pageDescription
              });
            }

            var media =
              response.data &&
              response.data.media &&
              response.data.media.map(image => {
                var imageData = {
                  _id: image._id,
                  mediaImage: image.mediaImage,
                  mediaUrl: image.mediaUrl
                };
                return imageData;
              });
            if (media) {
              this.setState({
                getAllArtistsPagedetails: response.data,
                error: response.data.error,
                loaderFlag: false,
                pageTitle: response.data.pageTitle,
                MsPartnerID: response.data._id,
                media: media !== undefined ? media : this.state.media,
                updateDate: response.data.updatedAt,
                updatedBy:response.data.updatedBy
              });
            } else this.setState({ loaderFlag: false });
          } else this.setState({ loaderFlag: false });

          break;
        case "FestivalVillage|ArtistLounge|ArtistLoungePage|create":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorPopup: true,
              errorMsg: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () => {
              this.apiserve.success("Artist Page Created successful.");
            });
            this.getArtists();
          }
          break;
        case "FestivalVillage|ArtistLounge|ArtistLoungePage|edit":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorPopup: true,
              errorMsg: response.data.error
            });
          } else {
            this.setState({ loaderFlag: false }, () => {
              this.apiserve.success("Artist Page Updated successful.");
            });
            this.getArtists();
          }
        break;
        case "FestivalVillage|Event|Preview|create":
          if (!response.error) {
              this.setState({
                  loaderFlag:false,
              },()=>{
              window.open(process.env.REACT_APP_FRONTEND_ORIGIN_FESTIVAL_VILLAGE + 'artist-preview');
              })
          }
          else
          {
              this.setState({
                  errorPopup:true,
                  errorMsg: response.data.error ? response.data.error : response.data 
              })
          }
      break;
      }
    });
  };

  getArtists = () => {
    this.apiserve.sendevent("FestivalVillage|ArtistLounge|ArtistLoungePage|getList", { limit: 10, page: 1 });
  };

  onChangeFile = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onloadend = (event) => {
      this.setState({
        file: file
        // base64: reader.result
      });
      if (
        (file && file.type === "image/png") ||
        (file && file.type === "image/jpg") ||
        (file && file.type === "image/jpeg")
      ) {
        const fileList = Math.round(file && file.size / 1024);
        if (fileList >= 2048) {
          this.setState({
            errorPopup: true,
            errorMsg: "Please upload a file smaller than 2 MB"
          });
          return false;
        }
        if (file && (file.type === "image/png" || file.type === "image/jpg" || file.type === "image/jpeg")) {
          // this.setState({ isImage: true });

          setTimeout(() => {
            this.uploadVideoImage(file, id,event.target.result);
          }, 0);
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
          });
        }
      } else {
        if (file.size > 200e6) {
          this.setState({
            errorPopup: true,
            errorMsg: "Please upload a video smaller than 200 MB"
          });
          return false;
        }

        if (file.type === "video/mp4") {
          setTimeout(() => {
            this.uploadVideoImage(file, id,event.target.result);
          }, 0);
          return false;
        } else {
          this.setState({
            errorPopup: true,
            errorMsg: "Please Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
          });
        }
      }
    };
  };

  onInputChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  onEditorStateChange = pageDescription => {
    this.setState({
      pageDescription
    });
  };

  submitFn = async e => {
    e.preventDefault();
    if (this.validator.allValid()) {
      const self = this;
      self.setState({ loaderFlag: true });
      const name = convertToRaw(self.state.pageDescription.getCurrentContent());
      const pageDescription = draftToHtml(name);
      self.state.media.forEach(element => {
        delete element._id;
      });
      var result = _.filter(_.uniq(self.state.media, function(item, key, a) {
        return item._id;
      }), function(element) {
        return element.mediaImage || element.mediaUrl
      });
      if (self.state.MsPartnerID) {
        let data = {
          id: this.state.MsPartnerID,
          pageTitle: self.state.pageTitle,
          pageDescription: pageDescription,
          media: self.state.media,
          frontMedia:result,
        };
        self.apiserve.sendevent("FestivalVillage|ArtistLounge|ArtistLoungePage|edit", data);
      } else {
        self.apiserve.sendevent("FestivalVillage|ArtistLounge|ArtistLoungePage|create", {
          pageTitle: self.state.pageTitle,
          pageDescription: pageDescription,
          media: self.state.media,
          frontMedia:result,
        });
      }
    }
    else{
        this.validator.showMessages();
        this.forceUpdate();
    }
  };

  previewRecord = (e) => {
    e.preventDefault()
    let previewDetails = {}
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const name = convertToRaw(this.state.pageDescription.getCurrentContent());
      const pageDescription = draftToHtml(name);
   
      var result = _.filter(_.uniq(this.state.media, function(item, key, a) {
        return item._id;
      }), function(element) {
        return element.mediaImage || element.mediaUrl
      });

        previewDetails = {
          pageTitle: this.state.pageTitle,
          pageDescription: pageDescription,
          media: this.state.media,
          frontMedia:result,
        }
        if (this.state.MsPartnerID) previewDetails.id = this.state.MsPartnerID
        let previewString = this.apiserve.encrypt(previewDetails)
        this.apiserve.sendevent("FestivalVillage|Event|Preview|create", {previewString});
    }else{
      this.validator.showMessages();
      this.forceUpdate();
  }
}

  uploadVideoImage = (file, id, img) => {
    const imagePreloaderId = `imagePreloader_${id}`;
    const newState = { ...this.state, videoPreLoader: true };
    newState[imagePreloaderId] = true;
    this.setState(newState);
    var fileSet= commonImage(file,false,'',img)
     fileSet.then((value) => {
      this.state.media.forEach(image => {
        const imagePreloaderId = `imagePreloader_${id}`;
        const newState = { ...this.state };
        newState[imagePreloaderId] = false;
        this.setState(newState);

        if (image._id === id) {
          image.mediaImage = value;
        }
      });
      this.setState({});
    });
  };
  setDeleteFilePopup = (e, id) => {
    this.setState({
      deleteImagePopup: true,
      deleteId: id
    });
  };

  onDeleteImagePopup = () => {
    this.state.media.forEach(image => {
      if (image._id === this.state.deleteId) {
        image.mediaImage = "";
      }
    });
    this.setState({
      deleteImagePopup: false
    });
  };
  closeAdminUser = () => {
    this.setState({ deleteImagePopup: false });
  };

  insideFilechange = (e, id) => {
    const { name, value } = e.target;
    this.state.media.forEach(image => {
      if (image._id === id) {
        image.mediaUrl = value;
      }
    });
    this.setState({});
  };

  errorMsgPopup = () => {
    this.setState({
      errorPopup: false
    });
  };

  render() {
    var settings = {
      customPaging: function (i) {
        return <a>{i + 1}</a>;
      },
      dots: true,
      arrows: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };
    const self = this;
    return (
      <>
        <div className="right_side_wrapper partnerEventAdminView_wrapper fest_contents ">
          <ul className="fpg_admin_tab disp_flex">
            <li className="active">
              <p className="text_left">
                <div>
                  {/* Adobe Premier
                  <label className="ml_15 mr_15">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M2.75 1.75C2.75 1.94778 2.69135 2.14112 2.58147 2.30557C2.47159 2.47002 2.31541 2.59819 2.13268 2.67388C1.94996 2.74957 1.74889 2.76937 1.55491 2.73079C1.36093 2.6922 1.18275 2.59696 1.04289 2.45711C0.903041 2.31725 0.8078 2.13907 0.769215 1.94509C0.73063 1.75111 0.750433 1.55004 0.826121 1.36732C0.901809 1.18459 1.02998 1.02841 1.19443 0.918531C1.35888 0.80865 1.55222 0.750001 1.75 0.750001C2.01522 0.750001 2.26957 0.855357 2.45711 1.04289C2.64464 1.23043 2.75 1.48478 2.75 1.75ZM6 0.750001C5.80222 0.750001 5.60888 0.80865 5.44443 0.918531C5.27998 1.02841 5.15181 1.18459 5.07612 1.36732C5.00043 1.55004 4.98063 1.75111 5.01922 1.94509C5.0578 2.13907 5.15304 2.31725 5.29289 2.45711C5.43275 2.59696 5.61093 2.6922 5.80491 2.73079C5.99889 2.76937 6.19996 2.74957 6.38268 2.67388C6.56541 2.59819 6.72159 2.47002 6.83147 2.30557C6.94135 2.14112 7 1.94778 7 1.75C7 1.48478 6.89464 1.23043 6.70711 1.04289C6.51957 0.855357 6.26522 0.750001 6 0.750001ZM10.25 2.75C10.4478 2.75 10.6411 2.69135 10.8056 2.58147C10.97 2.47159 11.0982 2.31541 11.1739 2.13268C11.2496 1.94996 11.2694 1.74889 11.2308 1.55491C11.1922 1.36093 11.097 1.18275 10.9571 1.04289C10.8173 0.903041 10.6391 0.8078 10.4451 0.769215C10.2511 0.73063 10.05 0.750433 9.86732 0.826121C9.68459 0.901809 9.52841 1.02998 9.41853 1.19443C9.30865 1.35888 9.25 1.55222 9.25 1.75C9.25 2.01522 9.35536 2.26957 9.54289 2.45711C9.73043 2.64464 9.98478 2.75 10.25 2.75ZM1.75 5C1.55222 5 1.35888 5.05865 1.19443 5.16853C1.02998 5.27841 0.901809 5.43459 0.826121 5.61732C0.750433 5.80004 0.73063 6.00111 0.769215 6.19509C0.8078 6.38907 0.903041 6.56725 1.04289 6.70711C1.18275 6.84696 1.36093 6.9422 1.55491 6.98079C1.74889 7.01937 1.94996 6.99957 2.13268 6.92388C2.31541 6.84819 2.47159 6.72002 2.58147 6.55557C2.69135 6.39112 2.75 6.19778 2.75 6C2.75 5.73478 2.64464 5.48043 2.45711 5.29289C2.26957 5.10536 2.01522 5 1.75 5ZM6 5C5.80222 5 5.60888 5.05865 5.44443 5.16853C5.27998 5.27841 5.15181 5.43459 5.07612 5.61732C5.00043 5.80004 4.98063 6.00111 5.01922 6.19509C5.0578 6.38907 5.15304 6.56725 5.29289 6.70711C5.43275 6.84696 5.61093 6.9422 5.80491 6.98079C5.99889 7.01937 6.19996 6.99957 6.38268 6.92388C6.56541 6.84819 6.72159 6.72002 6.83147 6.55557C6.94135 6.39112 7 6.19778 7 6C7 5.73478 6.89464 5.48043 6.70711 5.29289C6.51957 5.10536 6.26522 5 6 5ZM10.25 5C10.0522 5 9.85888 5.05865 9.69443 5.16853C9.52998 5.27841 9.40181 5.43459 9.32612 5.61732C9.25043 5.80004 9.23063 6.00111 9.26922 6.19509C9.3078 6.38907 9.40304 6.56725 9.54289 6.70711C9.68275 6.84696 9.86093 6.9422 10.0549 6.98079C10.2489 7.01937 10.45 6.99957 10.6327 6.92388C10.8154 6.84819 10.9716 6.72002 11.0815 6.55557C11.1914 6.39112 11.25 6.19778 11.25 6C11.25 5.73478 11.1446 5.48043 10.9571 5.29289C10.7696 5.10536 10.5152 5 10.25 5ZM1.75 9.25C1.55222 9.25 1.35888 9.30865 1.19443 9.41853C1.02998 9.52841 0.901809 9.68459 0.826121 9.86732C0.750433 10.05 0.73063 10.2511 0.769215 10.4451C0.8078 10.6391 0.903041 10.8173 1.04289 10.9571C1.18275 11.097 1.36093 11.1922 1.55491 11.2308C1.74889 11.2694 1.94996 11.2496 2.13268 11.1739C2.31541 11.0982 2.47159 10.97 2.58147 10.8056C2.69135 10.6411 2.75 10.4478 2.75 10.25C2.75 9.98478 2.64464 9.73043 2.45711 9.54289C2.26957 9.35536 2.01522 9.25 1.75 9.25ZM6 9.25C5.80222 9.25 5.60888 9.30865 5.44443 9.41853C5.27998 9.52841 5.15181 9.68459 5.07612 9.86732C5.00043 10.05 4.98063 10.2511 5.01922 10.4451C5.0578 10.6391 5.15304 10.8173 5.29289 10.9571C5.43275 11.097 5.61093 11.1922 5.80491 11.2308C5.99889 11.2694 6.19996 11.2496 6.38268 11.1739C6.56541 11.0982 6.72159 10.97 6.83147 10.8056C6.94135 10.6411 7 10.4478 7 10.25C7 9.98478 6.89464 9.73043 6.70711 9.54289C6.51957 9.35536 6.26522 9.25 6 9.25ZM10.25 9.25C10.0522 9.25 9.85888 9.30865 9.69443 9.41853C9.52998 9.52841 9.40181 9.68459 9.32612 9.86732C9.25043 10.05 9.23063 10.2511 9.26922 10.4451C9.3078 10.6391 9.40304 10.8173 9.54289 10.9571C9.68275 11.097 9.86093 11.1922 10.0549 11.2308C10.2489 11.2694 10.45 11.2496 10.6327 11.1739C10.8154 11.0982 10.9716 10.97 11.0815 10.8056C11.1914 10.6411 11.25 10.4478 11.25 10.25C11.25 9.98478 11.1446 9.73043 10.9571 9.54289C10.7696 9.35536 10.5152 9.25 10.25 9.25Z"
                        fill="white"
                      />
                    </svg>
                  </label> */}
                  Artist Home Page Content
                </div>
              </p>
            </li>
          </ul>
          {this.state.updateDate === undefined ? '' :
          <div className="back_date d_flex d_flex_align_center d_flex_justify_spacebt">
            <p></p>
            <p className="update_date">
              Last Update: {moment(this.state.updateDate).tz("US/Mountain").format('h')}:{moment(this.state.updateDate).tz("US/Mountain").format('mm')} {moment(this.state.updateDate).tz("US/Mountain").format('A')}{' '}
						MT- {moment.tz(this.state.updateDate, "US/Mountain").format('MM/DD/YYYY')}{' '}
              Last Updated By:{" "} {this.state.updatedBy && `${this.state.updatedBy.fname}${' '} ${this.state.updatedBy.lname} `}
            </p>
          </div>
          }
          <div className="tab-panels">
            <div className="tab-panel screenigBlock_wrapper PanelBlock_wrapper">
              <form className="ml_0">
                <div className="ml_15">
                  <div className="EventTitle_block">
                    <div className="textarea_block form_group">
                      <h5 className="left_label">Page Title</h5>
                      <div className="form_group_textarea">
                        <input
                          type="text"
                          name="pageTitle"
                          value={this.state.pageTitle}
                          onChange={this.onInputChange}
                          autoComplete="off"
                        />
                         <span className="error">
                            {this.validator.message("page title", self.state.pageTitle, "required")}
                          </span>
                      </div>
                    </div>
                  </div>
                  <div className="description_block">
                    <div className="textarea_block form_group">
                      <h5 className="left_label">Page Description </h5>
                      <div className="form_group_textarea editor_wrapper ml_25 editor_400">
                        <TextEditor
                          editorState={this.state.pageDescription}
                          name="pageDescription"
                          value={this.state.pageDescription}
                          onEditorStateChange={this.onEditorStateChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="EventTitle_block">
                    <div className="textarea_block form_group mr_25">
                      <h5 className="left_label">Detail Images or Videos</h5>
                    </div>
                    <div className="video_slider uploads_files mb_25" style={{ display: "block" }}>
                      <Slider {...settings}>
                        {this.state.media &&
                          this.state.media.map((item, i) => {
                            const imagePreloaderState = `imagePreloader_${item._id}`;
                            return this.state.isImage ||
                              item.mediaImage.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null ||
                              item.mediaUrl.match(/\.(jpeg|jpg|gif|png|jfif)$/) != null ? (
                                <div className=" file_upload_400 relative">
                                <div className="uploads_files">
                                  <VideoImageFile
                                    item={item._id}
                                    handleImage={e => this.onChangeFile(e, item._id)}
                                    iconDelete={true}
                                    size="2"
                                    id={item._id}
                                    image={item.mediaUrl}
                                    showDeleteIcon={item.mediaImage}
                                    value={
                                      item.mediaImage
                                        ? this.apiserve.imageUrl + item.mediaImage
                                        : item.mediaUrl
                                    }
                                    insideOnchange={e => this.insideFilechange(e, item._id)}
                                    videoPreLoader={this.state[imagePreloaderState]}
                                    deleteImage={e => this.setDeleteFilePopup(e, item._id)}
                                    isboth={true}
                                    textChange={true}
                                  />
                                </div>
                              </div>
                              ) : (
                                <div className="file_upload_400 relative">
                                <div className="uploads_files">
                                  <VideoOnlyUpload
                                    handleVideo={e => this.onChangeFile(e, item._id)}
                                    url={
                                      item.mediaImage
                                        ? `${this.apiserve.imageUrl}${item.mediaImage}`
                                        : item.mediaUrl
                                    }
                                    video={
                                      item.mediaImage
                                        ? `${this.apiserve.imageUrl}${item.mediaImage}`
                                        : item.mediaUrl
                                    }
                                    videoUrl={item.mediaUrl}
                                    insideOnchange={e => this.insideFilechange(e, item._id)}
                                    item={item}
                                    iconDelete={true}
                                    showDeleteIcon={item.mediaImage}
                                    videoPreLoader={this.state[imagePreloaderState]}
                                    // setErrorMsg={setErrorMsg} setErrorPopup={setErrorPopup}
                                    deleteVideo={e => this.setDeleteFilePopup(e, item._id)}
                                    uploadmessage="Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB"
                                  />
                                </div>
                              </div>
                                
                              );
                          })}
                      </Slider>
                    </div>
                  </div>
                  <div className="EventTitle_block">
                    <div className="textarea_block form_group">
                      <h5 className="left_label">&nbsp;&nbsp;&nbsp;&nbsp;</h5>
                      <div className="btn_wrapper field_row ml_25">
                        <button className="grayBTN">Cancel</button>
                        {this.state.MsPartnerID &&
                            <button className="uppercase prev_btn" type='button' onClick={(e)=>this.previewRecord(e)}>PREviEW</button>
                        }
                        <button className="orangeBTN" onClick={this.submitFn}>
                          Submit
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        {this.state.errorPopup ? (
          <ErrorPopUp errorMsg={this.state.errorMsg} errorMsgPopup={this.errorMsgPopup} />
        ) : (
            ""
          )}
        {/* {this.state.loaderFlag ? <Loader /> : ""} */}
        {this.state.deleteImagePopup ? (
          <PopUpCustomAll
            HeaderName="Delete Image?"
            insideDetails="Are You Sure ?"
            insideData="You want to delete this image"
            popupState={() => this.closeAdminUser()}
            yesPopUp={() => this.onDeleteImagePopup()}
          />
        ) : (
            ""
          )}
      </>
    );
  }
}
